import { render, staticRenderFns } from "./tax-info-needed.vue?vue&type=template&id=d702b33e"
import script from "./tax-info-needed.vue?vue&type=script&lang=js"
export * from "./tax-info-needed.vue?vue&type=script&lang=js"
import style0 from "./tax-info-needed.vue?vue&type=style&index=0&id=d702b33e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports